<template>
  <div class="insect-wrap" @>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    width: Number,
    height: Number
  }
}
</script>

<style lang="css" scoped>
.insect-wrap {
  user-select: none;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
}
</style>
